import React from 'react';
import { useContextSelector } from 'use-context-selector';
import { ScheduleContext } from '../contexts/ScheduleContext';
import { ProductItemProps } from '../models/Product';
import { ScheduleItemProps, ScheduleItemPropsBuilder } from '../models/Schedule';

export function useSchedulingMountMulti() {
  const [scheduleList, setScheduleList] = React.useState([] as ScheduleItemProps[]);
  const { addSchedulesStore, scheduleItems } = useContextSelector(ScheduleContext, state => state);

  function createMultipleSchedulesByProduct(products: ProductItemProps[]) {
    const multiSchedules = products.map(item => {
      const scheduleBuilder = ScheduleItemPropsBuilder();
      return scheduleBuilder.setProduct(item);
    });
    setScheduleList(multiSchedules);
    return multiSchedules;
  }

  function addPatient(patientId: string, schedules?: ScheduleItemProps[]) {
    const schedulesToSave = schedules?.length ? schedules : scheduleList;
    const multiSchedules = schedulesToSave.map(item => {
      const scheduleFactory = ScheduleItemPropsBuilder(item);
      return scheduleFactory.setPatient(patientId);
    });
    setScheduleList(multiSchedules);
    return multiSchedules;
  }

  function saveSchedules(schedules?: ScheduleItemProps[]) {
    const schedulesToSave = schedules?.length ? schedules : scheduleList;
    addSchedulesStore(schedulesToSave);
  }

  return {
    addPatient,
    createMultipleSchedulesByProduct,
    saveSchedules
  };
}
